import { render, staticRenderFns } from "./FormPageUnitSCT.vue?vue&type=template&id=29940dc1&"
import script from "./FormPageUnitSCT.vue?vue&type=script&lang=js&"
export * from "./FormPageUnitSCT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29940dc1')) {
      api.createRecord('29940dc1', component.options)
    } else {
      api.reload('29940dc1', component.options)
    }
    module.hot.accept("./FormPageUnitSCT.vue?vue&type=template&id=29940dc1&", function () {
      api.rerender('29940dc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageUnitSCT.vue"
export default component.exports